import { render, staticRenderFns } from "./Attorney.vue?vue&type=template&id=44dab01c&scoped=true&"
import script from "./Attorney.vue?vue&type=script&lang=js&"
export * from "./Attorney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dab01c",
  null
  
)

export default component.exports